import { React } from 'Imports';
import { createContext, useContext } from 'react';

interface AppInitializationContextValue {
    isAppInitialized: boolean;
}

const AppInitializationContext = createContext<AppInitializationContextValue>({
    isAppInitialized: false,
});

export const useAppInitialization = (): AppInitializationContextValue => {
    return useContext(AppInitializationContext);
};

export { AppInitializationContext };
